import { useGetAccessibleLivePagesQuery } from "@/shared/services";
import { useMemo } from "react";
import { isHostPage } from "./standalone-version";

/**
 * The ids of the host pages in reach -- the hidden page each user's
 * standalone versions hang off (see ./standalone-version).
 *
 * A host page is not a story, but it is a real page and analytics files a
 * standalone version's sessions under it, so its id turns up wherever a
 * story is picked by id. Lists that offer STORIES leave it out; everything
 * that shows the VERSIONS themselves -- the version lists and filters, the
 * sessions, the totals -- is untouched, because those key on the version.
 *
 * The page list is the one every other caller already reads, so this costs
 * nothing: React Query hands back the same cached array.
 */
export const useHostPageIds = (): Set<string> => {
  const { data: pages = [] } = useGetAccessibleLivePagesQuery();
  return useMemo(
    () => new Set(pages.filter(isHostPage).map((page) => page._id)),
    [pages],
  );
};
